module.exports = __webpack_public_path__ + "static/Yrittäjä-3e58ee69a17a518bf04bc67d2f3f7036.png";